import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import SqftFeaturesPopupFeature from "./sqftFeaturesPopupFeature";
import SqftFeaturesPopupParentListTitle from "./sqftFeaturesPopupParentListTitle";

const SqftFeaturesPopupParentList = (props) => {
  const { parentsList, parentsLists, rebuildQuoteLists, setParentsLists } = props;

  if (!parentsList || Object.keys(parentsList).length === 0) {
    return null;
  }

  return (
    <div className="ui-popup__body-parentlist">
      {Object.keys(parentsList).map(function (parentKey) {
        let parent = parentsList[parentKey];

        if (!parent
          || !parent.subPart
          || (!parent.features || parent.features.length === 0)
          && (!parent.featuresSubGroups || parent.featuresSubGroups.length === 0)) {
          return null;
        }
        const firstFeature = parent.features[0];

        return (
          <div className="sqft-popup__group" key={parentKey}>
            <SqftFeaturesPopupParentListTitle
              parentsList={parentsList}
              parentKey={parentKey}
              parentsLists={parentsLists}
              setParentsLists={setParentsLists}
              rebuildQuoteLists={rebuildQuoteLists}
              subPart={parent.subPart}
              fromWizardGroupId={firstFeature ? firstFeature.fromWizardGroupId : null}
            />

            {parent.features && parent.features.length > 0 && (
              <ul className="sqft-popup__list">
                {parent.features.map(function (sqftFeature, sqftFeatureIndex) {
                  if (sqftFeature) {
                    return (
                      <SqftFeaturesPopupFeature
                        key={"sqftFeature-" + parentKey + "-" + sqftFeatureIndex}
                        parentKey={parentKey}
                        parentsList={parentsList}
                        parentsLists={parentsLists}
                        setParentsLists={setParentsLists}
                        sqftFeature={sqftFeature}
                        rebuildQuoteLists={rebuildQuoteLists}
                      />
                    );
                  }
                })}
              </ul>
            )}

            {parent.featuresSubGroups && parent.featuresSubGroups.length > 0 && (
              parent.featuresSubGroups.map(function (featureGroup, groupIndex) {
                return (
                  <div key={"featureGroup-" + parentKey + "-" + groupIndex} className="sqft-popup__feature-group">
                    {featureGroup.subGroupTitle && featureGroup.features.length > 0 && (
                      <div className="bold u-ml-3 u-pl-075 scart-block__title-room u-w-auto">
                        {featureGroup.subGroupTitle}
                      </div>
                    )}
                    {featureGroup.features && featureGroup.features.length > 0 && (
                      <ul className="sqft-popup__list">
                        {featureGroup.features.map(function (sqftFeature, sqftFeatureIndex) {
                          if (sqftFeature) {
                            return (
                              <SqftFeaturesPopupFeature
                                key={"sqftFeature-" + parentKey + "-group-" + groupIndex + "-" + sqftFeatureIndex}
                                parentKey={parentKey}
                                parentsList={parentsList}
                                parentsLists={parentsLists}
                                setParentsLists={setParentsLists}
                                sqftFeature={sqftFeature}
                                rebuildQuoteLists={rebuildQuoteLists}
                              />
                            );
                          }
                        })}
                      </ul>
                    )}
                  </div>
                );
              })
            )}
          </div>
        );
      })}
    </div>
  );
};

SqftFeaturesPopupParentList.propTypes = {
  parentsList: PropTypes.object,
  parentsLists: PropTypes.array,
  setParentsLists: PropTypes.func.isRequired,
  rebuildQuoteLists: PropTypes.func,
};

const mapStateToProps = function (store) {
  return {
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupParentList));
